import { Divider, Stack } from '@mui/material';

import { say } from '@/james-playground/aa-family-claim/claim/asks';
import { entry } from '@/james-playground/aa-family-claim/claim/registry';
import { labelOf } from '@/james-playground/aa-family-claim/claim/labels';
import {
  CardShell,
  EntryToggle,
  optionText,
  useDraft,
} from '@/james-playground/aa-family-claim/claim/cards/parts';
import { type CardProps } from '@/james-playground/aa-family-claim/claim/cards/types';
import { str } from '@/james-playground/aa-family-claim/claim/cards/values';

/**
 * Quick checks DWP asks everyone, a Yes or No each, with the form's own
 * "Do not know" where it has one. A follow-up the form only asks after a Yes,
 * like writing in Welsh, appears under the answer that opens it.
 */
const QuickChecksCard = ({
  ask,
  facts,
  voice: v,
  onSubmit,
  onSkip,
}: CardProps) => {
  const { draft, set, visible, values } = useDraft(ask, facts);
  const ids = ask.entries.filter(visible);
  const asked = ids.filter((id) => entry(id).requiredness !== 'optional');
  const ready = asked.every((id) => str(draft[id]));

  const submit = () => {
    const out = values(ids);
    onSubmit(
      out,
      ids
        .filter((id) => out[id])
        .map((id) => `${labelOf(id, v)}: ${optionText(id, str(out[id]), v)}`)
        .join(' · '),
    );
  };

  return (
    <CardShell
      label={say(ask.title, v)}
      ready={ready}
      onContinue={submit}
      onSkip={onSkip}
    >
      <Stack spacing={1.75} divider={<Divider flexItem />}>
        {ids.map((id) => (
          <EntryToggle
            key={id}
            id={id}
            v={v}
            value={str(draft[id])}
            onChange={(value) => set(id, value)}
          />
        ))}
      </Stack>
    </CardShell>
  );
};

QuickChecksCard.displayName = 'QuickChecksCard';
export default QuickChecksCard;
